const state = {
  id: null,
  name: null,
  city: null,
  country: null
};

const mutations = {
  setHotel: (state, hotel) => {
    state.id = hotel.id;
    state.name = hotel.name;
    state.city = hotel.city;
    state.country = hotel.country;
  }
};

const actions = {
  setHotel: ({commit}, hotel) => {
    commit('setHotel', hotel);
  }
};

const getters = { };

const hotel = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default hotel;